import { Board } from './Board';
import { BADGE_LEGEND } from './badges';
import { LastUpdated } from '../../../hooks/useAutoRefresh';

const PERIODS = [['week', 'This week'], ['month', 'This month'], ['all', 'All time']];

export const Leaderboard = ({ data, period, setPeriod, dates, updatedAt }) => {
  return (
    <section className="relative overflow-hidden rounded-3xl bg-[#071434] p-5 sm:p-6 space-y-5 shadow-[0_20px_60px_-20px_rgba(7,20,52,0.6)]" data-testid="leaderboard">
      <style>{'@keyframes sbIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}.sb-in{animation:sbIn .45s ease-out both}'}</style>
      <div className="pointer-events-none absolute inset-0 opacity-[0.07] bg-[linear-gradient(rgba(255,255,255,.6)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.6)_1px,transparent_1px)] bg-[size:28px_28px]" />
      <div className="pointer-events-none absolute -top-24 left-1/3 w-[480px] h-48 rounded-full bg-teal-400/20 blur-3xl" />
      <div className="relative flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <p className="text-[10px] tracking-[0.3em] text-teal-300 font-semibold">REFERRAL LEAGUE</p>
          <h3 className="font-outfit text-3xl font-black text-white tracking-tight">Leaderboard</h3>
          <p className="text-xs text-white/50 mt-1">Ranked by paid conversions (ties: consultations booked, assessments completed, registrations). Students count in the period they registered. Same dates as the Detailed breakdown below.</p>
          <div className="mt-1"><LastUpdated at={updatedAt} testId="leaderboard-updated-at" dark /></div>
        </div>
        <div className="flex flex-col items-start sm:items-end gap-1 shrink-0">
        <div className="inline-flex shrink-0 whitespace-nowrap p-1 rounded-full bg-white/5 border border-white/10 self-start sm:self-end">
          {PERIODS.map(([id, label]) => (
            <button key={id} type="button" onClick={() => setPeriod(id)} data-testid={`period-tab-${id}`}
              className={`rounded-full text-xs sm:text-sm px-4 py-1.5 font-semibold transition-colors ${period === id ? 'bg-teal-400 text-[#071434]' : 'text-white/60 hover:text-white'}`}>{label}</button>
          ))}
        </div>
        <span className="text-[11px] text-white/55" data-testid="leaderboard-date-range">
          {period === 'custom' ? 'Custom dates: ' : ''}{dates.date_from || dates.date_to ? `${dates.date_from || 'start'} → ${dates.date_to || 'today'}` : 'All dates'}
        </span>
        </div>
      </div>
      {data ? (
        <div key={period} className="relative grid grid-cols-1 2xl:grid-cols-2 gap-5 items-start">
          <Board title="Campus Ambassadors" rows={data.campus_ambassador} testId="board-ambassadors" />
          <Board title="Internal Team" rows={data.internal_team} testId="board-team" />
        </div>
      ) : <div className="relative h-64 rounded-2xl bg-white/5 animate-pulse" data-testid="leaderboard-loading" />}
      <div className="relative flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-white/45" data-testid="badge-legend">
        {BADGE_LEGEND.map(({ id, label, Icon, hint }) => <span key={id} className="inline-flex items-center gap-1"><Icon className="w-3 h-3" /><b className="text-white/80">{label}</b> {hint}</span>)}
      </div>
    </section>
  );
};
